import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./Home";
import About from "./About";
import Header from "./Header";
import "./App.css";
import Footer from "./Footer";

import FreeTrial from "./FreeTrial";
import FreeVocaIntro from "./FreeVocaIntro";
import FreeVocaLesson from "./FreeVocaLesson";
import FreeFuncIntro from "./FreeFuncIntro";
import FreeFuncLesson from "./FreeFuncLesson";
import FreeGrammarIntro from "./FreeGrammarIntro";
import FreeGrammarLesson from "./FreeGrammarLesson";
import FreeWritingIntro from "./FreeWritingIntro";
import FreeWritingLesson from "./FreeWritingLesson";
import FreeTensesLesson from "./FreeTensesLesson";
import FreeTensesIntro from "./FreeTensesIntro";
import FreeVocaExercises from "./FreeVocaExercises";
import FreeFuncExercises from "./FreeFuncExercises";
import FreeGrammarExercises from "./FreeGrammarExercises";
import FreeWritingExercises from "./FreeWritingExercises";
import FreeTensesExercises from "./FreeTensesExercises";

import CourseTenses from "./CourseTenses";
import CourseFunctions from "./CourseFunctions";
import CourseVocabulary from "./CourseVocabulary";
import CourseGrammar from "./CourseGrammar";
import CourseWriting from "./CourseWriting";
import CourseReadingComprehension from "./ReadingComprehension";
import NationalExams from "./NationalExams";

import { AuthProvider } from "./context/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import AdminDashboard from "./AdminPanel/AdminDashboard";
import AdminRoute from "./AdminPanel/AdminRoute";
import Login from "./Login";

function AppContent() {
  const location = useLocation();

  const hideHeader =
    location.pathname.startsWith("/freetrial") ||
    location.pathname.includes("/login") ||
    location.pathname.includes("/course") ||
    location.pathname.startsWith("/admin");

  const hideFooter =
    location.pathname.includes("/login") ||
    location.pathname === "/" ||
    location.pathname.includes("/course") ||
    location.pathname.startsWith("/admin");

  return (
    <div>
      {!hideHeader && <Header />}

      <Routes>
        {/* Public */}
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />

        {/* Free trial */}
        <Route path="/freetrial" element={<FreeTrial />} />
        <Route path="/freetrial/vocabulary/introduction" element={<FreeVocaIntro />} />
        <Route path="/freetrial/vocabulary/gifts-of-youth" element={<FreeVocaLesson />} />
        <Route path="/freetrial/functions/introduction" element={<FreeFuncIntro />} />
        <Route path="/freetrial/functions/expressing-opinion" element={<FreeFuncLesson />} />
        <Route path="/freetrial/grammar/introduction" element={<FreeGrammarIntro />} />
        <Route path="/freetrial/grammar/Gerund-and-infinitive" element={<FreeGrammarLesson />} />
        <Route path="/freetrial/writing/introduction" element={<FreeWritingIntro />} />
        <Route path="/freetrial/writing/descriptive-paragraph" element={<FreeWritingLesson />} />
        <Route path="/freetrial/tenses/introduction" element={<FreeTensesIntro />} />
        <Route path="/freetrial/tenses/irregular-verbs" element={<FreeTensesLesson />} />

        {/* Exercises */}
        <Route path="/freetrial/vocabulary/exercises" element={<FreeVocaExercises />} />
        <Route path="/freetrial/functions/exercises" element={<FreeFuncExercises />} />
        <Route path="/freetrial/grammar/exercises" element={<FreeGrammarExercises />} />
        <Route path="/freetrial/writing/exercises" element={<FreeWritingExercises />} />
        <Route path="/freetrial/tenses/irregular-verbs-pdf" element={<FreeTensesExercises />} />

        {/* Login */}
        <Route path="/login" element={<Login />} />

        {/* Protected courses (NO localStorage, only context memory) */}
        <Route path="/tenses/course" element={<ProtectedRoute><CourseTenses /></ProtectedRoute>} />
        <Route path="/functions/course" element={<ProtectedRoute><CourseFunctions /></ProtectedRoute>} />
        <Route path="/vocabulary/course" element={<ProtectedRoute><CourseVocabulary /></ProtectedRoute>} />
        <Route path="/grammar/course" element={<ProtectedRoute><CourseGrammar /></ProtectedRoute>} />
        <Route path="/writing/course" element={<ProtectedRoute><CourseWriting /></ProtectedRoute>} />
        <Route path="/reading-comprehension/course" element={<ProtectedRoute><CourseReadingComprehension /></ProtectedRoute>} />
        <Route path="/national-exams/pdfs" element={<ProtectedRoute><NationalExams /></ProtectedRoute>} />

        {/* Admin */}
        <Route path="/admin/*" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
      </Routes>

      {!hideFooter && <Footer />}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}